import React from "react";
import styled from "styled-components";

const FileListTable: React.FC<{
  head: React.ReactNode;
  rows: React.ReactNode;
}> = ({ head, rows }) => {
  return (
    <TableContainer>
      <Table>
        <thead>{head}</thead>
        <tbody>{rows}</tbody>
      </Table>
    </TableContainer>
  );
};

export default FileListTable;

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
  gap: 20px;
  border-radius: 8px;
  background: white;
  th {
    cursor: pointer;
  }
  width: 100%;
`;

const Table = styled.table`
  border-collapse: collapse;
  th {
    text-align: left;
    box-sizing: border-box;
    padding: 12px 24px 12px 12px;
    gap: 12px;
    width: fit-content;
    height: 44px;
    background: #ffffff;
    border-bottom: 1px solid #eaecf0;
    align-self: stretch;
    width: 29px;
    height: 18px;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #00022f;
  }
  td {
    box-sizing: border-box;
    padding: 8px 24px 8px 12px;
    gap: 12px;
    width: 237px;
    height: 54px;
    border-bottom: 1px solid #eaecf0;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #808080;
  }
`;
